// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"855b2034","488":"b269e5a1","712":"83120f28","742":"77ac6044"}[chunkId] + ".chunk.js";
};